import { freeze, assign } from 'icepick';
import omit from 'lodash/omit';
import without from 'lodash/without';
import {
	DELETE_COMPONENT_FAILURE,
	DELETE_COMPONENT_SUCCESS,
	type DeleteComponentFailureAction,
	type DeleteComponentSuccessAction,
} from '../../actions';
import {
	DELETE_COMPONENT_STARTED,
	DELETE_COMPONENT_DIALOG_DISPLAYED,
	DELETE_COMPONENT_CANCEL,
	type DeleteComponentStartedAction,
	type DeleteComponentDialogDisplayedAction,
	type DeleteComponentCancelAction,
} from './actions';

export type DeleteState = {
	componentsBeingDeleted: string[];
	spinner: {
		[key: string]: boolean;
	};
};

type Action =
	| DeleteComponentStartedAction
	| DeleteComponentDialogDisplayedAction
	| DeleteComponentSuccessAction
	| DeleteComponentCancelAction
	| DeleteComponentFailureAction;

export const initialState: DeleteState = freeze({
	componentsBeingDeleted: [],
	spinner: {},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: DeleteState = initialState, action: Action): DeleteState => {
	switch (action.type) {
		case DELETE_COMPONENT_STARTED: {
			return freeze({
				...state,
				spinner: {
					...state.spinner,
					[action.payload.id]: true,
				},
				componentsBeingDeleted: [...state.componentsBeingDeleted, action.payload.id],
			});
		}

		case DELETE_COMPONENT_DIALOG_DISPLAYED: {
			return freeze({
				...state,
				spinner: omit(state.spinner, action.payload.id),
			});
		}

		case DELETE_COMPONENT_FAILURE: {
			const componentsBeingDeleted = action.payload.isDialogOpen
				? state.componentsBeingDeleted
				: without(state.componentsBeingDeleted, action.payload.id);

			return assign(state, {
				spinner: omit(state.spinner, action.payload.id),
				componentsBeingDeleted,
			});
		}

		case DELETE_COMPONENT_CANCEL:
		case DELETE_COMPONENT_SUCCESS: {
			return freeze({
				...state,
				componentsBeingDeleted: without(state.componentsBeingDeleted, action.payload.id),
				spinner: omit(state.spinner, action.payload.id),
			});
		}

		default:
			return state;
	}
};
